import {HttpRequest} from '@angular/common/http';

import {Injectable} from '@angular/core';
import {AuthService} from "@app/core/services/auth.service";
import {environment} from "@environments/environment";

@Injectable()
export class TokenInterceptor {

  constructor(private authService: AuthService) {
  }

  addToken(req: HttpRequest<any>): HttpRequest<any> {
    if (this.isNonApiRequest(req.url)) {
      return req;
    }
    const token = this.authService.getToken();
    const url = environment.endPoint + req.url;
    if (token) {
      return req.clone({
        headers: req.headers.set('Authorization-Token', token),
        url
      });
    } else {
      return req.clone({
        url
      });
    }
  }

  /** Frontend static assets and absolute URLs must not be prefixed with the API base. */
  private isNonApiRequest(url: string): boolean {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return true;
    }
    const normalized = url.replace(/^\.\//, '');
    return normalized.startsWith('assets/');
  }
}
